import { z } from 'zod';
/** Reviewed local teaching models; Markdown cannot supply executable JavaScript. */
export const learningLabSchema = z
    .object({
    version: z.literal(1),
    exploration: z
        .object({
        question: z.string().min(1).max(500),
        rounds: z
            .array(z
            .object({
            title: z.string().min(1).max(100),
            action: z.string().min(1).max(900),
            predict: z.string().min(1).max(500),
            explanation: z.string().min(1).max(1200),
        })
            .strict())
            .min(2)
            .max(4),
        transfer: z.string().min(1).max(700),
    })
        .strict()
        .optional(),
    kind: z.enum([
        'relationship-map',
        'transaction-journal',
        'contract-gates',
        'page-window',
        'document-compare',
        'session-timeline',
        'token-gates',
        'permission-matrix',
        'browser-boundaries',
        'dom-event',
        'promise-exchange',
        'response-race',
        'async-lanes',
        'socket-state',
        'retry-ledger',
        'test-boundaries',
        'application-map',
        'python-program',
        'test-bench',
        'persistence',
        'fde-roles',
        'requirements',
        'python-values',
        'python-trace',
        'git-staging',
        'json-inspector',
        'http-inspector',
        'rest-matrix',
        'fastapi-trace',
        'sql-workbench',
        'frontend-states',
        'debugging',
    ]),
})
    .strict();
